import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-menu\"><defs><style type=\"text/css\"></style></defs><path d=\"M 915.17 234.67 c 24.73 0 44.79 -17.92 44.79 -40 s -20.06 -40 -44.79 -40 H 108.81 c -24.74 0 -44.81 17.91 -44.81 40 s 20.07 40 44.81 40 Z M 915.17 552 c 24.73 0 44.79 -17.93 44.79 -40 s -20.02 -40 -44.79 -40 H 460.81 c -24.74 0 -44.81 17.91 -44.81 40 s 20.07 40 44.81 40 Z M 70.33 498.18 a 18.73 18.73 0 0 0 -1.74 26.32 c 0.46 0.58 1.16 1.16 1.74 1.75 L 262.64 694 a 9.39 9.39 0 0 0 15.5 -7.11 V 337.08 a 9.34 9.34 0 0 0 -15.5 -7 Z M 108.81 789.33 c -24.74 0 -44.81 17.92 -44.81 40 s 20.07 40 44.81 40 H 915.17 c 24.73 0 44.79 -17.91 44.79 -40 s -20.06 -40 -44.79 -40 Z\" fill=\"#999999\" p-id=\"2362\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu.svg
// module id = dH9r
// module chunks = 3